module.exports = "<div *ngIf=\"displayError\" >\r\n        <div class=\"error-msg\">\r\n                {{ errorMsg }}\r\n        </div>\r\n</div>"